import fetch from '../../../../utils/fetch'
import * as types from './mutation_types'

export const getItems = ({ commit }, { sortBy, page }) => {
  commit(types.TOGGLE_LOADING)
  commit(types.SET_ERROR, '')

  let pageUrl = 'categories?'
  if (sortBy) {
    pageUrl = pageUrl + sortBy
  } else {
    pageUrl = pageUrl + 'order[name]=asc'
  }

  if (page) {
    pageUrl = page
  }

  return fetch(pageUrl)
    .then(response => response.json())
    .then((data) => {
      commit(types.SET_ITEMS, data['hydra:member'])
      commit(types.SET_VIEW, data['hydra:view'])
    })
    .catch((e) => {
      commit(types.SET_ERROR, e.message)
    })
    .finally(() => {
      commit(types.TOGGLE_LOADING)
    })
}
